module.exports = __webpack_public_path__ + "eot/am-icon-font.870e4a.eot";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/am-icon-font.eot
 ** module id = 313
 ** module chunks = 12
 **/